import { EditOutlined, FlagOutlined } from '@ant-design/icons';
import { Button, Col, Divider, Image, Row, Space, Typography } from 'antd';
import React, { CSSProperties } from 'react';
import { Link } from 'react-router-dom';

import { Issue } from '@/data/issues';

import { Agree, Disagree } from './VoteResult';

const { Title, Paragraph } = Typography;

export type IssueListProps = {
  issues: Issue[];
  style?: CSSProperties;
  isEditMode?: boolean;
};

function IssueList(props: IssueListProps) {
  const { issues, style, isEditMode = false } = props;

  return (
    <Space direction="vertical" split={<Divider />} style={style}>
      {issues.map((issue) => {
        return (
          <Link key={issue.title} to={`/issue/${issue.title.replaceAll(' ', '-')}`}>
            <Row gutter={20}>
              <Col span={14}>
                <Title level={2}>{issue.title}</Title>
                <Title level={5}>{issue.date}</Title>
                <Paragraph>{issue.description}</Paragraph>
              </Col>
              <Col span={10}>
                <Image width="100%" src={issue.image} preview={false} />
              </Col>
              {isEditMode && (
                <Col span={24}>
                  <Row gutter={16} style={{ marginTop: '16px', marginBottom: '16px' }}>
                    <Col span={12}>
                      <Agree />
                    </Col>
                    <Col span={12}>
                      <Disagree />
                    </Col>
                  </Row>
                  <Space>
                    <Button type="primary" icon={<EditOutlined />}>
                      Edit
                    </Button>
                    <Button type="primary" icon={<FlagOutlined />}>
                      Finished Issue Early
                    </Button>
                  </Space>
                </Col>
              )}
            </Row>
          </Link>
        );
      })}
    </Space>
  );
}

export default IssueList;
